var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "rb-accordion",
    {
      staticClass: "rb-faq-accordion",
      on: { clicked: _vm.setIsOpen },
      scopedSlots: _vm._u(
        [
          {
            key: "title",
            fn: function () {
              return [_vm._t("accordion_title")]
            },
            proxy: true,
          },
          {
            key: "icon",
            fn: function () {
              return [_c("rb-lazy-icon", { attrs: { icon: _vm.getIcon } })]
            },
            proxy: true,
          },
        ],
        null,
        true
      ),
    },
    [
      _vm._v(" "),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "rb-faq-accordion__content" },
        [_vm._t("default")],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }